function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "asset_per_mappa");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "ASSET"
}, /*#__PURE__*/React.createElement("path", {
  d: "M39.75,19.82a14,14,0,0,1-5.55-1.47,14.11,14.11,0,0,0-5.63-1.48,14.28,14.28,0,0,0-4.95,1.3,18.34,18.34,0,0,1-6.82,1.65,10.75,10.75,0,0,1-5.14-1.46,11,11,0,0,0-5.4-1.49V15.4A12.47,12.47,0,0,1,12.32,17a9.27,9.27,0,0,0,4.48,1.31,17,17,0,0,0,6.28-1.55,15.25,15.25,0,0,1,5.49-1.4A15.13,15.13,0,0,1,34.78,17a12.67,12.67,0,0,0,5,1.35,8.9,8.9,0,0,0,4.9-1.44,9.54,9.54,0,0,1,5.09-1.51v1.47a8.05,8.05,0,0,0-4.37,1.33A10.46,10.46,0,0,1,39.75,19.82Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41,23.51a16.61,16.61,0,0,1-6.06-1.46,16.89,16.89,0,0,0-6.26-1.49,16.79,16.79,0,0,0-5.51,1.31,21.88,21.88,0,0,1-7.46,1.64A10.52,10.52,0,0,1,10.37,22a10.82,10.82,0,0,0-5.59-1.48V19.08A12.32,12.32,0,0,1,11,20.73,9,9,0,0,0,15.66,22a20.6,20.6,0,0,0,7-1.55,18,18,0,0,1,6-1.4,18,18,0,0,1,6.79,1.59A15.09,15.09,0,0,0,41,22a8.64,8.64,0,0,0,5-1.43,9.25,9.25,0,0,1,5.22-1.52v1.48a7.74,7.74,0,0,0-4.48,1.32A10.2,10.2,0,0,1,41,23.51Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.27,30.37V40.6H5.22s.35-6.31,6.3-6.31,6.29,6.31,6.29,6.31h2V30.37Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.76,30.37V40.6H21.7s.36-6.31,6.3-6.31,6.3,6.31,6.3,6.31h1.94V30.37Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M36.24,30.37V40.6h1.95s.35-6.31,6.29-6.31,6.3,6.31,6.3,6.31h1.95V30.37Z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 3.27,
  y: 27.17,
  width: 49.45,
  height: 2.52
}));

var SvgIcoUnderwater = function SvgIcoUnderwater(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 56 56",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcoUnderwater, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ico_underwater.e67e0750.svg";
export { ForwardRef as ReactComponent };